import Vue from 'vue';
import Meta from 'vue-meta';
import VueApollo from 'vue-apollo';
import { SitecoreJssPlaceholderPlugin } from '@sitecore-jss/sitecore-jss-vue';
import AppRoot from './AppRoot';
import { createRouter } from './router';
import store from './store';
import SitecoreJssStorePlugin from './lib/SitecoreJssStorePlugin';
import GraphQLClientFactory from './lib/GraphQLClientFactory';
import config from './temp/config.js';
import componentFactory from './temp/componentFactory';
import vuetify from './vuetify';
import challengerEnv from './lib/challengerEnv';
import VueLoggerPlugin from './globalHandler/vue-logger';
import envConfigPlugin from './globalHandler/envConfigPlugin';
import filters from './filters';

new Vue();
Vue.filter('fixTelephoneLink', filters.fixTelephoneLink);
Vue.use(vuetify, {
  iconfont: 'material-icons',
});
Vue.use(Meta);
Vue.use(SitecoreJssStorePlugin);
Vue.use(SitecoreJssPlaceholderPlugin, { componentFactory });
Vue.use(VueApollo);

export function createGraphQLProvider(initialState) {
  // CUSTOM - read the hostname for content service from the challenger config not the JSS
  let graphQlEndpoint = config.graphQLEndpoint;
  if (challengerEnv().sitecoreContentAPI.host && challengerEnv().sitecoreContentAPI.host !== '') {
    graphQlEndpoint =
      challengerEnv().sitecoreContentAPI.host +
      '/api/iol?sc_apikey=' +
      challengerEnv().sitecoreContentAPI.key;
  }

  const client =
    initialState && initialState.APOLLO_STATE
      ? GraphQLClientFactory(graphQlEndpoint, false, initialState.APOLLO_STATE)
      : GraphQLClientFactory(graphQlEndpoint, true);

  const provider = new VueApollo({
    defaultClient: client,
  });

  return provider;
}

// createApp is invoked by both the main and SSR entry points, so the two entry points can use the same app creation process.
export function createApp(initialState, i18n, logger, envConfig) {
  Vue.config.productionTip = false;
  Vue.use(VueLoggerPlugin, logger);
  Vue.use(envConfigPlugin, envConfig);

  const router = createRouter('/', envConfig);
  const graphQLProvider = createGraphQLProvider(initialState);

  const vueOptions = {
    apolloProvider: graphQLProvider,
    router,
    store,
    vuetify,
    render: (createElement) => createElement(AppRoot),
  };
  // conditionally add i18n to the Vue instance if it is defined
  if (i18n) {
    vueOptions.i18n = i18n;
  }

  const app = new Vue(vueOptions);

  // if there is an initial state defined, push it into the store, where it can be referenced by interested components.
  if (initialState) {
    app.$jss.store.setSitecoreData(initialState);
  }

  return { app, router, graphQLProvider };
}
